
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Settings, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const RevenueSettingsCard: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <TrendingUp className="mr-2 h-5 w-5" /> Revenue Settings
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-gray-600 mb-4">
          Configure revenue sharing percentages and payment settings for your resellers.
        </p>
        <Button 
          variant="outline" 
          className="w-full flex justify-center items-center"
          onClick={() => navigate('/master/settings?tab=revenue')}
        >
          <Settings className="mr-2 h-4 w-4" />
          Manage Revenue Settings
        </Button>
      </CardContent>
    </Card>
  );
};

export default RevenueSettingsCard;
